const header = document.querySelector('.header');

// let lastScrollTop = 0;

function checkScrollTop() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;

  // if (scrollTop > lastScrollTop) {
  //   header.classList.add('is-top');
  // } else {
  //   header.classList.remove('is-top');
  // }

  if (scrollTop <= 16) {
    header.classList.remove('is-scroll');
  } else {
    header.classList.add('is-scroll');
  }

  // lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}

window.addEventListener('scroll', checkScrollTop);
document.addEventListener('DOMContentLoaded', checkScrollTop);
